import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar'
import MainPage from './components/MainPage';
import CompareWorkshopsPage from './components/CompareWorkshopsPage';
import LandUseComparisonPage from './components/LandUseComparisonPage';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    
      <div className="hero is-fullheight-with-navbar">
        <Navbar />
        <div className="navbarPadding">
          <Routes >
            <Route path="/" element={<MainPage />} />
            <Route path="/compare/:idString" element={<CompareWorkshopsPage />} />
            <Route path="/land-use-comparison" element={<LandUseComparisonPage />} />
          </Routes>
          <Footer />
        </div>        
    </div>
  );
}


export default App;
